import { Api, getLspReportBppId } from '@/lib/utils'
import { useStore } from '@/store'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'

export const Route = createFileRoute('/_auth/reports/lsp')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { token, accountId, setPage } = useStore(useShallow(state => ({
    token: state.token,
    accountId: state.selectedAccount.id,
    setPage: state.setPage,
  })))

  const bppId = getLspReportBppId(accountId)

  useEffect(() => {
    setPage('Reports')
  }, [setPage])

  useEffect(() => {
    if (!bppId) {
      navigate({ to: '/reports', replace: true })
    }
  }, [bppId, navigate])

  const getLspReport = useQuery({
    queryKey: ['lsp_report', token, bppId],
    queryFn: () => Api<{ status: number, embed_link: string }>('/webui/reports/lsp', 'POST', { bpp_id: bppId }, { token }),
    staleTime: Infinity,
    refetchInterval: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!bppId,
  })

  return (
    <div className="absolute left-0 right-0 md:top-15 bottom-3 md:px-5 md:py-3 px-2">
      <div className="absolute left-2 right-2 bottom-2 top-0 overflow-auto lg:left-5 lg:right-5">
        {getLspReport.data?.embed_link ? (
          <div onMouseDown={e => e.stopPropagation()}>
            <iframe src={getLspReport.data.embed_link} className="absolute right-0 top-0 bottom-0 left-0 w-full h-full" />
          </div>
        ) : getLspReport.isFetching ? (
          <div className="w-full h-full flex justify-center items-center">
            <Loader2 />
          </div>
        ) : null}
      </div>
    </div>
  )
}
